<template>
  <div
    v-on-click-outside="hideDropdown"
    class="w-full relative border border-solid border-grey-700 bg-grey-800 rounded-lg"
  >
    <div class="relative" @click="showDropdown">
      <input
        ref="input"
        type="text"
        :value="formatInput"
        :placeholder="placeholder"
        class="w-full h-8 outline-none rounded-lg px-4 text-white bg-grey-800"
        @keydown="disableDeleteOption"
      />
      <span
        class="absolute top-0 right-0 mt-2 mr-2 text-grey-500"
        @click="toggleDropdown"
      >
        <arrow-down class="h-4 w-4 fill-current"></arrow-down>
      </span>
    </div>

    <div
      v-show="dropDownOpen"
      class="multiselect-dropdown overflow-x-hidden rounded-b-lg bg-grey-800"
    >
      <div
        v-for="(option, idx) in formattedOptions"
        :key="idx"
        class="multiselect-item px-3 py-2 border-t border-grey-700 text-white cursor-pointer"
        :class="multiselectClass(option, idx)"
        @click="select($event, option, idx)"
      >
        {{ option.text }}
      </div>
    </div>
  </div>
</template>

<script>
import ArrowDown from '@fortawesome/fontawesome-free/svgs/solid/angle-down.svg';
import directives from '../directives';

export default {
  name: 'MultiSelect',
  components: {
    ArrowDown,
  },
  directives,
  props: {
    value: {},
    options: {},
    placeholder: {},
    inputMask: {},
  },
  data() {
    return {
      dropDownOpen: false,
      selectedItems: [],
    };
  },
  computed: {
    formattedOptions() {
      if (!this.options) return this.navigationPages || [];
      if (this.options[0] && this.options[0].value) return this.options;
      else
        return this.options.map((option) => {
          return { text: option, value: option };
        });
    },
    navigationPages() {
      let pages = this.$store.getters.onPageNavigation;
      return pages.map((page) => {
        return { text: page.name, value: page.name };
      });
    },
    formatInput() {
      if (this.inputMask) {
        return this.selectedItems
          .map((selectedEl) => {
            return this.formattedOptions.find((el) => selectedEl === el.value)
              .text;
          })
          .join(', ');
      } else {
        return this.selectedItems.join(', ');
      }
    },
  },
  mounted() {
    let availableItems = this.formattedOptions.map((el) => el.value);
    if (this.value) {
      this.selectedItems = this.value
        .slice()
        .filter((item) => availableItems.includes(item));
    }
  },
  methods: {
    showDropdown() {
      this.dropDownOpen = true;
    },
    hideDropdown() {
      this.dropDownOpen = false;
    },
    toggleDropdown(e) {
      e.stopPropagation();
      this.dropDownOpen = !this.dropDownOpen;
    },
    disableDeleteOption(e) {
      if (e.keyCode === 8 || e.keyCode === 46) {
        e.preventDefault();
      }
    },
    select(e, option, index) {
      let el = e.target;
      if (el.classList.contains('multiselect-item--selected')) {
        let itemIdxInSelectedItems = this.selectedItems.findIndex(
          (item) => item == option.value
        );
        this.selectedItems.splice(itemIdxInSelectedItems, 1);
        this.$emit('change', this.selectedItems);
      } else {
        this.selectedItems.splice(index, 0, option.value);
        this.$emit('change', this.selectedItems);
      }
    },
    multiselectClass(option) {
      if (this.selectedItems.includes(option.value)) {
        return 'multiselect-item--selected';
      }
    },
  },
};
</script>

<style lang="scss">
.multiselect-dropdown {
  max-height: 200px;
}
.multiselect-item {
  &--selected {
    background: #fd6481;
  }
}
</style>
